module.exports = __webpack_public_path__ + "img/credenciales-google.d825870d.svg";